var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-category-item",class:{'catalog-category-item-active': _vm.category.id === _vm.filter.category}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.category.image.path,"alt":""}})]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.category.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }